"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WALLET_TRANSACTION_TYPE = exports.WALLET_HISTORY_STATUS = exports.WALLET_CODE = exports.TRIP_TYPE = exports.TRAVELLER_ACTION_TYPES = exports.STORAGE_KEYS = exports.PRODUCT_TYPES = exports.PAYMENT_STATUS = exports.ORDER_STATUS = exports.ENDPOINTS = exports.BOOKING_TYPES = exports.AUTH_TOKEN_MAX_AGE = exports.ACTION_TYPES = exports.ACCOUNT_TYPE = exports.ACCOUNT_STATUS = exports.ACCOMMODATION_BOOKING_STATUS = void 0;
var ENDPOINTS = {
  USER: '/api/account/v2/user/{userId}',
  ME: '/api/account/v2/user/me',
  DELETE_ACCOUNT: '/api/account/v2/delete/user',
  ORDERS_V1: '/api/hotel/order/user',
  ORDERS: '/api/account/v2/order/user',
  RETRIEVE_ORDER: '/api/enigma/order/{number}',
  RETRIEVE_FLIGHTS_ORDER: '/api/v3/flights/flight/order',
  CONTACT: '/api/account/contact',
  BILLING: '/api/account/billing',
  TRAVELLER: '/api/account/traveller/{id}',
  TRAVELLERS: '/api/account/traveller',
  CREATE_TRAVELLER: '/api/account/traveller',
  UPDATE_TRAVELLER: '/api/account/traveller/{id}',
  DELETE_TRAVELLER: '/api/account/traveller/{id}',
  REGISTER: '/api/account/v2/user',
  LOGIN: '/api/account/v2/auth/local',
  SIGN_IN_WITH_APPLE: '/api/account/auth/social/apple-native',
  DELETE_APPLE_ACCOUNT: '/api/account/v2/delete/social/user',
  OAUTH_LOGIN: '/auth/social/{platform}',
  FORGOT_PASSWORD: '/api/account/v2/password/forgot',
  RESET_PASSWORD_EMAIL: '/api/account/v2/password/email/set',
  RESET_PASSWORD_PHONE: '/api/account/v2/password/phone/set',
  VERIFY_RESET_PASSWORD: '/api/account/v2/user/{token}/reset',
  UPDATE_REGISTRATION: '/api/account/v2/user/update/registration',
  SUBSCRIBE: '/api/account/newsletter/subscribe',
  CHANGE_PASSWORD: '/api/account/user/{userId}/password',
  VERIFY_USER_EMAIL: '/api/account/v2/email/verify',
  REFRESH_TOKEN: '/api/account/v2/user/auth/refresh',
  RESEND_VERIFY_EMAIL: 'api/account/v2/email/send-verification',
  RESEND_VERIFY_PHONE: 'api/account/v2/phone/send-verification',
  CHECK_OTP_STATUS: 'api/account/v2/otp/status?token={token}&requestId={requestId}',
  VERIFY_USER_PHONE: '/api/account/v2/phone/verify',
  LOYALTY_CHECK_HISTORY: '/api/loyalty/check-history',
  LOYALTY_CHECK_BALANCE: '/api/loyalty/check-balance',
  CMS_PAGE: '/api/cms/page',
  USER_LINK_ORDER: '/api/account/v2/link/order',
  SUBMIT_PROMO: '/api/account/v2/user/promotions'
};
exports.ENDPOINTS = ENDPOINTS;
var STORAGE_KEYS = {
  AUTH_TOKEN: 'token',
  USER_HASHING: 'md5_user',
  USER_BASE64: 'base64_user'
};
exports.STORAGE_KEYS = STORAGE_KEYS;
var AUTH_TOKEN_MAX_AGE = 14;
exports.AUTH_TOKEN_MAX_AGE = AUTH_TOKEN_MAX_AGE;
var ACCOUNT_TYPE = {
  LOCAL: 'local',
  SOCIAL: 'social'
};
exports.ACCOUNT_TYPE = ACCOUNT_TYPE;
var ACCOUNT_STATUS = {
  ACTIVE: 'active'
};
exports.ACCOUNT_STATUS = ACCOUNT_STATUS;
var ACTION_TYPES = {
  FETCH_USER: 'FETCH_USER',
  UPDATE_USER: 'UPDATE_USER',
  SUBMIT_PROMO: 'SUBMIT_PROMO'
};
exports.ACTION_TYPES = ACTION_TYPES;
var TRAVELLER_ACTION_TYPES = {
  FETCH_TRAVELLER: 'FETCH_TRAVELLER',
  CREATE_TRAVELLER: 'CREATE_TRAVELLER',
  UPDATE_TRAVELLER: 'UPDATE_TRAVELLER',
  DELETE_TRAVELLER: 'DELETE_TRAVELLER'
};
exports.TRAVELLER_ACTION_TYPES = TRAVELLER_ACTION_TYPES;
var PRODUCT_TYPES = {
  FLIGHT: 'flight',
  HOTEL: 'hotel',
  ACCOMMODATION: 'accommodation',
  GIFTCARD: 'gift-card'
};
exports.PRODUCT_TYPES = PRODUCT_TYPES;
var BOOKING_TYPES = {
  UPCOMING: 'upcoming',
  PAST: 'past'
};
exports.BOOKING_TYPES = BOOKING_TYPES;
var ACCOMMODATION_BOOKING_STATUS = {
  SUCCESS: 58,
  FAILURE: 60,
  CANCELLED: 94,
  REFUNDED: 95,
  MANUALLY_CANCELLED: 96,
  CANCEL_ON_PROCESSING: 102
};
exports.ACCOMMODATION_BOOKING_STATUS = ACCOMMODATION_BOOKING_STATUS;
var PAYMENT_STATUS = {
  PENDING: 71
};
exports.PAYMENT_STATUS = PAYMENT_STATUS;
var ORDER_STATUS = {
  CANCELLED: 94,
  MANUALLY_CANCELLED: 96
};
exports.ORDER_STATUS = ORDER_STATUS;
var TRIP_TYPE = {
  roundtrip: 'Roundtrip',
  oneway: 'Oneway',
  multicity: 'MultiCity'
};
exports.TRIP_TYPE = TRIP_TYPE;
var WALLET_CODE = {
  USER_NOT_ENROLLED: 8004
};
exports.WALLET_CODE = WALLET_CODE;
var WALLET_TRANSACTION_TYPE = {
  REDEEM: 'REDEEM',
  REWARD: 'REWARD',
  EXPIRED: 'EXPIRED',
  REFUND: 'RFD',
  EMKAN: 'EMK'
};
exports.WALLET_TRANSACTION_TYPE = WALLET_TRANSACTION_TYPE;
var WALLET_HISTORY_STATUS = {
  AVAILABLE: 'Available',
  CANCELLED: 'Cancelled',
  EXPIRED: 'Expired',
  REDEEMED: 'Redeemed',
  PENDING: 'Pending'
};
exports.WALLET_HISTORY_STATUS = WALLET_HISTORY_STATUS;